export default "__VITE_ASSET__Bj_g2x_e__"